import React from 'react';

/**
 * What Build made, on the mission's card: the painted scene with every thing where it stands (the game's own layout -
 * o.style, backend game.build_game - no image calls), and a row of the things' pictures. Read-only: clicking the scene,
 * or one thing, opens the Scene Arranger (on that thing).
 */
const API_BASE = process.env.REACT_APP_API_URL || '';
const asset = (src) => (src && src.startsWith('/game-builder-assets') ? `${API_BASE}${src}` : src);

export default function ScenePreview({ spec, onOpen }) {
  // a thing made during the game (the printed label) isn't in the scene; a place is only a ring in the arranger
  // the main room only: what stands in the game's other views (sections of the work area) isn't drawn on it
  const things = spec.items.filter((o) => !o.inv?.made_by && o.kind !== 'place' && !o.view);
  return (
    <div className="gb-preview">
      <button type="button" className="gb-preview-scene" style={{ backgroundImage: spec.background_src ? `url(${asset(spec.background_src)})` : undefined }}
        aria-label="The scene - open it to arrange" onClick={() => onOpen(null)}>
        {spec.items.filter((o) => o.kind === 'place' && o.inv?.zone && !o.view).map((o) => (     // areas of the floor, as the game marks them
          <span key={o.id} className={`gb-preview-zone gb-preview-zone-${o.inv.zone}`} style={o.style}>{o.item || o.name}</span>
        ))}
        {things.filter((o) => o.src).map((o) => (
          <img key={o.id} src={asset(o.src)} alt="" style={o.flipped ? { ...o.style, scale: '-1 1' } : o.style} draggable={false} />
        ))}
      </button>
      <ul className="gb-preview-things" aria-label="Things in the scene">
        {things.map((o) => (
          <li key={o.id}>
            <button type="button" title={`${o.item} - change its picture or place`} onClick={() => onOpen(o.item)}>
              {o.src ? <img src={asset(o.src)} alt="" /> : <span aria-hidden="true">{o.inv?.icon || '❔'}</span>}
              <span>{o.item}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
